import { Container, Divider, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import { Breadcrumb } from '../../components/common/Breadcrumb';
import { EmployeeDictionaryTiles, EmployeeImportUpload } from '../../features/employee-hub';

export const OperationsEmployeeHub: React.FC = () => {
    return (
        <Container size="xl" py="xl">
            <Stack gap="xs" mb="xl">
                <Breadcrumb
                    items={[
                        { label: 'Operations Panel', href: '/operations' },
                        { label: 'Employee', isActive: true },
                    ]}
                />
                <Title order={1} size="h2" fw={700}>
                    Employee
                </Title>
                <Text c="dimmed" size="lg">
                    Manage employee data and imports
                </Text>
            </Stack>

            <EmployeeImportUpload />

            <Divider my="xl" />

            <Title order={2} size="h3" fw={600} mb="md">
                Dictionary Management
            </Title>
            <EmployeeDictionaryTiles />
        </Container>
    );
};
